import clsx from 'clsx'
import { type ForwardedRef, forwardRef } from 'react'

import {
  type SelectFieldProps,
  SelectField as SharedSelectField,
} from '@fv/client-components'

export const SelectField = forwardRef(
  (
    { className, ...props }: SelectFieldProps,
    ref: ForwardedRef<HTMLSelectElement>,
  ) => (
    <SharedSelectField
      className={clsx('form-control form-control--select', className)}
      ref={ref}
      {...props}
    />
  ),
)
